import { type UserContext } from '@common/defaults/UserContext';
import { getStatus } from '@common/supertokens/getStatus';
import { SupertokensStatus } from '@common/supertokens/SupertokensStatus';

/**
 * use status check
 */
export const checkAuthStatus = async (
    isClientSide: boolean,
    userContext: UserContext | undefined,
): Promise<void> => {
    return new Promise((resolve, reject) => {
        const status = getStatus(userContext, isClientSide);

        if (status === SupertokensStatus.NEEDS_REFRESH) {
            reject(new Error('401: Needs Refresh'));
        }

        // no need to do anything, just resolve
        resolve();
    });
};
